module.exports = __webpack_public_path__ + "static/img/文案策划-social文案.eb2089c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10008/文案策划-social文案.png
// module id = clnA
// module chunks = 1